import { __awaiter, __generator } from "tslib";
import { getServiceForProduct } from './get-service-for-product';
import { isProductServiceAllowedForLocale } from './is-product-service-allowed-for-locale';
import { isServiceAllowedForLocale } from './is-service-allowed-for-locale';
export var getProductItemServiceMetadata = function (productItem, productItems, serviceType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                var serviceMetadata, _a, linkedService, isServiceAllowedOnLocale, linkedProduct, hasProductServiceAttached, _b, linkedService, isProductServiceAllowedOnLocale, error_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 6, , 7]);
                            serviceMetadata = {
                                serviceData: undefined,
                                shouldServiceItemBeDisplayed: false,
                                isService: false,
                            };
                            serviceMetadata.isService = productItem.c_isService && productItem.c_serviceType === serviceType;
                            if (!serviceMetadata.isService) return [3 /*break*/, 2];
                            return [4 /*yield*/, getLinkedServiceAndLocaleAllowed(productItem.product_id, serviceType)];
                        case 1:
                            _a = _c.sent(), linkedService = _a.linkedService, isServiceAllowedOnLocale = _a.isServiceAllowedOnLocale;
                            serviceMetadata.shouldServiceItemBeDisplayed = !linkedService && isServiceAllowedOnLocale;
                            linkedProduct = productItems === null || productItems === void 0 ? void 0 : productItems.find(function (item) { return item.item_id === productItem.c_serviceMasterID; });
                            serviceMetadata.serviceData = {
                                product: linkedProduct,
                                service: productItem,
                                serviceSku: productItem.product_id,
                            };
                            resolve(serviceMetadata);
                            return [3 /*break*/, 5];
                        case 2:
                            hasProductServiceAttached = productItems === null || productItems === void 0 ? void 0 : productItems.find(function (item) { return (item.c_serviceMasterID === productItem.item_id) && item.c_serviceType === serviceType; });
                            if (!hasProductServiceAttached) return [3 /*break*/, 3];
                            serviceMetadata.shouldServiceItemBeDisplayed = false;
                            resolve(serviceMetadata);
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, getLinkedServiceAndLocaleAllowed(productItem.product_id, serviceType)];
                        case 4:
                            _b = _c.sent(), linkedService = _b.linkedService, isProductServiceAllowedOnLocale = _b.isProductServiceAllowedOnLocale;
                            serviceMetadata.shouldServiceItemBeDisplayed = !!linkedService && isProductServiceAllowedOnLocale;
                            serviceMetadata.serviceData = {
                                product: productItem,
                                service: null,
                                serviceSku: linkedService === null || linkedService === void 0 ? void 0 : linkedService.sku,
                            };
                            resolve(serviceMetadata);
                            _c.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            error_1 = _c.sent();
                            reject(console.log('Error during getting service meta data:', error_1));
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            }); })];
    });
}); };
var getLinkedServiceAndLocaleAllowed = function (productId, serviceType) { return __awaiter(void 0, void 0, void 0, function () {
    var linkedService, isProductServiceAllowedOnLocale, isServiceAllowedOnLocale;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getServiceForProduct(productId, serviceType)];
            case 1:
                linkedService = _a.sent();
                return [4 /*yield*/, isProductServiceAllowedForLocale(productId, serviceType)];
            case 2:
                isProductServiceAllowedOnLocale = _a.sent();
                return [4 /*yield*/, isServiceAllowedForLocale(productId, serviceType)];
            case 3:
                isServiceAllowedOnLocale = _a.sent();
                return [2 /*return*/, { linkedService: linkedService, isProductServiceAllowedOnLocale: isProductServiceAllowedOnLocale, isServiceAllowedOnLocale: isServiceAllowedOnLocale }];
        }
    });
}); };
